import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});


const getownerhorseStats = createSlice({
    name: 'ownerhorsestats',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchownerhorseStats.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchownerhorseStats.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE
            })
            .addCase(fetchownerhorseStats.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            })
    }
});

export const { setTrainer, setStatus } = getownerhorseStats.actions;
export default getownerhorseStats.reducer;

export const fetchownerhorseStats = createAsyncThunk('/ownerhorsestats/fetch', async ({ id, currentPage }) => {
    const res = await axios.get(`${getBaseUrl()}/OwnerHorses/${id}?page=${currentPage}`);
    const trainerstatsData = res.data;
    return trainerstatsData;
})